import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Card } from "react-bootstrap";
import { DragDropContext, Draggable, Droppable } from "@hello-pangea/dnd";
import { QuestionTypeEnum } from "../../../../Constants";
import { Row, Form, Col, Button } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import {
  InputControl,
  InputValidationConstants,
  createOptionsFromEnum,
  SelectControl,
  CheckboxControl,
} from "wup-module1-base";
import { useState } from "react";
import { toast } from "react-toastify";

function PageQuestions({
  fields,
  register,
  errors,
  move,
  remove,
  append,
  update,
  getValues,
  pageId,
}) {
  const [isEdit, setIsEdit] = useState(null);
  const [pageQuestion, setPageQuestion] = useState(null);

  const handleDrop = (droppedQuestion) => {
    console.log(droppedQuestion);
    if (!droppedQuestion.destination) return;
    if (droppedQuestion.destination.droppableId === "container")
      move(droppedQuestion.source.index, droppedQuestion.destination.index);
    else {
      remove(droppedQuestion.source.index);
      // const question = fields[droppedQuestion.source.index];
      // if (question.relatedQuestions?.length > 0)
      //   toast.warn(
      //     "Nie można usunąć pytań zawierających pytania powiązane. Aby je usunąć, usuń pytania skorelowane w widoku edycji pytania."
      //   );
      // else {
      //   remove(droppedQuestion.source.index);
      //   reloadMethod();
      // }
    }
  };

  const handleTransferButtonClick = (question, idx) => {};

  const handleAddButtonClick = () => {
    const length = fields.length;
    const question = {
      id: uuidv4(),
      name: null,
      type: null,
      description: null,
      content: null,
      order: length + 1,
      pageId: pageId,
      relatedQuestions: [],
      newQuestion: true,
    };
    append(question);
  };

  return (
    <>
      <p className="fw-700 mb-2">Pytania</p>
      <Card className={"droppable-card"}>
        {fields.length > 0 && (
          <DragDropContext onDragEnd={handleDrop}>
            <Droppable droppableId="container">
              {(provided) => (
                <Card.Body {...provided.droppableProps} ref={provided.innerRef}>
                  {fields.map((question, index) => (
                    <Draggable
                      key={question.id}
                      draggableId={question.id}
                      index={index}
                    >
                      {(provided) => (
                        <>
                          <Row
                            className="droppable-row py-2 px-4 m-2 no-select"
                            ref={provided.innerRef}
                            {...provided.dragHandleProps}
                            {...provided.draggableProps}
                          >
                            <Col>
                              <InputControl
                                id={`questions.${index}.name`}
                                label={"Nazwa"}
                                readOnly={!question.newQuestion}
                                errors={errors}
                                refs={{
                                  ...register(`questions.${index}.name`, {
                                    required: InputValidationConstants.required,
                                  }),
                                }}
                              />
                            </Col>
                            <Col md={4}>
                              <SelectControl
                                id={`questions.${index}.type`}
                                label={"Typ"}
                                errors={errors}
                                options={createOptionsFromEnum(
                                  QuestionTypeEnum,
                                  false
                                )}
                                readOnly={!question.newQuestion}
                                refs={{
                                  ...register(`questions.${index}.type`, {
                                    required: InputValidationConstants.required,
                                  }),
                                }}
                              />
                            </Col>
                            <Col
                              md={"auto"}
                              className="d-flex"
                              style={{
                                alignItems: "center",
                              }}
                            >
                              <Button
                                variant="outline-info"
                                style={{
                                  marginTop: "0.88rem",
                                  marginRight: "0.2rem",
                                }}
                                // onClick={() => editQuestion(question, index)}
                              >
                                <FontAwesomeIcon
                                  className="mr-2"
                                  icon={faEdit}
                                />
                                Edytuj
                              </Button>
                            </Col>
                            {question.relatedQuestions?.length > 0 && (
                              <Col md={12}>
                                <i
                                  style={{
                                    fontWeight: "lighter",
                                  }}
                                >
                                  Zawiera pytania skorelowane
                                </i>
                              </Col>
                            )}
                          </Row>
                        </>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </Card.Body>
              )}
            </Droppable>
            <Droppable droppableId="trash-bin">
              {(provided) => (
                <Card.Body
                  className="border-danger border droppable-trash-can rounded mx-5 my-3 pb-4"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  <Row className="justify-content-center align-items-center">
                    <Col md={"auto"} className="text-center text-danger ">
                      <FontAwesomeIcon icon={faTrashCan} size="2x" />
                      <span className="mx-2 text-monospace font-weight-bold">
                        Przeciągnij, aby usunąć
                      </span>
                    </Col>
                  </Row>
                  {provided.placeholder}
                </Card.Body>
              )}
            </Droppable>
          </DragDropContext>
        )}
        <Row className="justify-content-center align-items-center pb-3">
          <Col md={"auto"}>
            <Button
              className="px-3"
              type="button"
              variant="primary"
              onClick={() => handleAddButtonClick()}
            >
              Dodaj pytanie
            </Button>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default PageQuestions;
